import { toast, Typography } from "@suraasa/placebo-ui"
import api from "api"
import SelectableCard from "features/Onboarding/Components/SelectableCard"
import { getNavigationPortal } from "features/Onboarding/Navigation/utils"
import { FormPageProps } from "features/Onboarding/types"
import { useState } from "react"

const options = [
  { label: "Yes", value: true },
  { label: "No", value: false },
]

const SeekingJob = ({ data, updateData, onNext, ...props }: FormPageProps) => {
  const [isSeekingJob, setIsSeekingJob] = useState<boolean | null>(
    data.seekingJob ?? null
  )

  const updateBackend = async (value: boolean) => {
    try {
      await api.profile.update({
        data: {
          looking_for_jobs: value,
        },
      })
    } catch (e) {
      console.error("Failed to update backend:", e)
    }
  }
  const handleSelection = (value: boolean) => {
    setIsSeekingJob(value)
    updateData({ seekingJob: value })
  }

  const handleSubmit = async () => {
    if (isSeekingJob === null) {
      toast.error("Please select an option")
      return
    }
    await updateBackend(isSeekingJob)
    await onNext()
  }

  const isDisabled = isSeekingJob === null

  return (
    <div className="flex flex-col items-start">
      <Typography variant="title2" color="onSurface.900">
        Are you actively looking for jobs?
      </Typography>
      <div className="mt-4 flex w-full max-w-[480px] flex-col gap-1">
        {options.map(option => (
          <SelectableCard
            key={option.label}
            selected={isSeekingJob === option.value}
            type="radio"
            onClick={() => handleSelection(option.value)}
          >
            <Typography variant="subtitle2">{option.label}</Typography>
          </SelectableCard>
        ))}
      </div>

      {getNavigationPortal({
        disableNext: isDisabled,
        onNext: handleSubmit,
        ...props,
      })}
    </div>
  )
}

export default SeekingJob
